import React, { useState } from 'react';
import Layout from '../../../../components/Layout/Layout';
import { Col, Alert, Table, FormGroup, Button } from 'reactstrap';
import ProfileCard from '../../components/ProfileCard/ProfileCard';
import ProfileNav from '../../components/ProfileNav/ProfileNav';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { connect } from 'react-redux';
import Card from '../../../../components/Card/Card';
import EditNotificationsSMS from '../../../../components/Notifications/EditNotificationsSMS';
import { FMessage } from '../../../../hoc/IntlComponents';

import CustomControl from '@components/CustomControl/CustomControl';
import TwoFactorActivateBlock from '@components/TwoFactorAuth/TwoFactorActivateBlock';

import { authList } from '@components/TwoFactorAuth/twoFactorAuthHelpers';
import ChangePasswordBlock from '../../../../components/Password/ChangePasswordBlock';

const { SMS, GAUTH, TELEGRAM } = authList;

const SecurityPage = ({
  sms_payout,
  isLoading,
  isActivating,
  enableTwoFactorAuth,
  disableTwoFactorAuth,
  activateTwoFactorAuth,
  isActivateButtonRendering,
  isAuthMethodEnabled,
  responseInfo,
  two_factor,
  profile,
  onSubmit,
  showBotInfo,
  botsInfo,
}) => {
  const [alertMessage, setAlertMessage] = useState('');

  const openAlert = message => {
    setAlertMessage(message);
  };

  const alertOnDismiss = () => {
    setMessage('');
  };

  const { sessionId, validTill, message, code } = responseInfo;

  return (
    <Layout className="security-page" formattedTitle="pages.security.title">
      <Col xs="12">
        <h3 className="page-title">
          <FormattedMessage id="navigation.sidebar.security.title" defaultMessage="Security" />
        </h3>
      </Col>
      <Col lg="4">
        <Card>
          <Card.Body>
            <ProfileCard />
          </Card.Body>
        </Card>
        <Card>
          <ProfileNav />
        </Card>
      </Col>
      <Col lg="8">
        <ChangePasswordBlock />

        <Card>
          <Card.Header>
            <FormattedMessage
              id="pages.profile.security.two-factor"
              defaultMessage="Two-factor authentication"
            />
          </Card.Header>
          <Card.Body className="text-center no-padding">
            {alertMessage && (
              <Alert color="success" toggle={alertOnDismiss}>
                {alertMessage}
              </Alert>
            )}
            <Table className="no-margin" bordered responsive>
              <tbody>
                {sms_payout && (
                  <tr>
                    <td className="title">
                      <FMessage id="edit_notification.theme.3" />
                    </td>
                    <td>
                      <EditNotificationsSMS openAlert={openAlert} />
                    </td>
                  </tr>
                )}
                <tr>
                  <td className="title" rowSpan="2">
                    <FMessage id="two_factor_auth.theme.3" />
                  </td>
                  <td>
                    {/* <FormGroup>
                      <CustomControl
                        id={`two_factor_sms`}
                        name="two_factor_sms"
                        type="radio"
                        className="custom-control-xs"
                        value={1}
                        onChange={enableTwoFactorAuth.bind(null, SMS)}
                        checked={isAuthMethodEnabled(SMS)}
                        disabled={two_factor.type === 2 && two_factor.is_active}
                      >
                        <FormattedMessage
                          id="pages.profile.security.controls.sms"
                          defaultMessage="Via SMS"
                        />
                      </CustomControl>
                    </FormGroup> */}
                    <FormGroup>
                      <CustomControl
                        id={`two_factor_gauth`}
                        name="two_factor_gauth"
                        type="radio"
                        className="custom-control-xs"
                        value={1}
                        onChange={enableTwoFactorAuth.bind(null, GAUTH)}
                        checked={isAuthMethodEnabled(GAUTH)}
                        disabled={two_factor.type !== 2 && two_factor.is_active}
                      >
                        <FormattedMessage
                          id="pages.profile.security.controls.gauth"
                          defaultMessage="Via Google Auth"
                        />
                      </CustomControl>
                    </FormGroup>

                    <FormGroup>
                      <CustomControl
                        id={`two_factor_telegram`}
                        name="two_factor_telegram"
                        type="radio"
                        className="custom-control-xs"
                        value={1}
                        onChange={enableTwoFactorAuth.bind(null, TELEGRAM)}
                        checked={isAuthMethodEnabled(TELEGRAM)}
                        disabled={two_factor.type !== 4 && two_factor.is_active}
                      >
                        <FormattedMessage
                          id="pages.profile.security.controls.telegram"
                          defaultMessage="Via Telegram"
                        />
                      </CustomControl>
                    </FormGroup>
                  </td>
                </tr>

                {isActivateButtonRendering() && (
                  <tr>
                    <td>
                      <FormGroup className="security-page-button">
                        <Button color="primary" type="button" onClick={activateTwoFactorAuth}>
                          <FormattedMessage
                            id="pages.profile.security.button.enable"
                            defaultMessage="Enable"
                          />
                        </Button>
                      </FormGroup>
                    </td>
                  </tr>
                )}

                {two_factor.is_active === 1 && !isActivating && (
                  <tr>
                    <td>
                      <FormGroup className="security-page-button">
                        <Button
                          color="primary"
                          type="button"
                          onClick={() => disableTwoFactorAuth()}
                        >
                          <FormattedMessage
                            id="pages.profile.security.button.disable"
                            defaultMessage="Disable"
                          />
                        </Button>
                      </FormGroup>
                    </td>
                  </tr>
                )}

                {showBotInfo && (
                  <tr>
                    <td colSpan="2" className="telegram-info">
                      <FormattedHTMLMessage
                        tagName="p"
                        id="pages.profile.security.telegram.auth-err"
                        values={botsInfo}
                      />
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            {/* <CustomTable bordered responsive stripped aria-label="Secutiry">
                                <CustomTableWrapper>
                                    <CustomTableRow>
                                        <CustomTableCell>
                                            Date
                                        </CustomTableCell>
                                        <CustomTableCell>
                                            Time
                                        </CustomTableCell>
                                        <CustomTableCell>
                                            IP
                                        </CustomTableCell>
                                    </CustomTableRow>
                                </CustomTableWrapper>
                            </CustomTable> */}
          </Card.Body>

          {isActivating && (
            <Card.Body>
              <TwoFactorActivateBlock
                sessionId={sessionId}
                validTill={validTill}
                onSubmit={onSubmit}
                error={message}
                status={code}
                two_factor={two_factor}
                phone={profile.phone}
              />
            </Card.Body>
          )}
        </Card>
      </Col>
    </Layout>
  );
};

const mapStateToProps = ({ webmaster }) => ({
  sms_payout: webmaster.profile.sms_payout,
});

// const mapDispatchToProps = dispatch => ({
//     startSetProfile: () => dispatch(startSetProfile()),
// });

export default connect(mapStateToProps)(SecurityPage);
